// extracted by mini-css-extract-plugin
module.exports = {"img":"styles_img__qId3m","ready":"styles_ready__f_F6_"};